<script setup>
import { onMounted } from "vue";
const BrowserLogger = require("@arms/js-sdk");
onMounted(() => {
  let scene = "";
  switch (process.env.DEFINE_NODE_ENV) {
    case "prod":
      scene = "prod";
      break;
    default:
      scene = "local";
      break;
  }
  BrowserLogger.singleton({
    pid: "jn9dyban6b@eba3fe3332f9437",
    appType: "web",
    imgUrl: "https://arms-retcode.aliyuncs.com/r.png?",
    sendResource: true,
    enableLinkTrace: true,
    behavior: true,
    useFmp: true,
    enableSPA: true,
    environment: scene,
  });
});
// import { setSession } from "@/utils/storage";
// import { getUserInfo } from "@/libs/apis/dataApis";
// import Cookies from "js-cookie";

// export default {
// onLaunch: function () {
// window.quickChatReadyHook = () => {
//   console.log("访客端初始化完成");
// };
// console.log("App Launch");
// const token = Cookies.get("service_center_user_rbac_token_c");
// if (token) {
//   this.userInfo();
// }
// },
// onShow: function () {
//   console.log("App Show");
// const token = Cookies.get("service_center_user_rbac_token_c");
// if (!token) {
//   uni.navigateTo({
//     url: "/pages/login/index",
//   });
// }
// },
// methods: {
// userInfo() {
//   getUserInfo()
//     .then((res) => {
//       if (res?.data) {
//         setSession("userInfo", res?.data);
//       }
//     })
//     .catch((err) => {
//       console.log("getUserInfo---err", err);
//       // if (err?.code === 40004) {
//       //   uni.navigateTo({
//       //     url: "/pages/login/index",
//       //   });
//       //    Cookies.remove("service_center_user_rbac_token_c", {
//       //""
//       // domain: ".popmart.com",
//       // secure: true,
//       // });
//       // }
//     });
// },
// },
// onHide: function () {
//   console.log("App Hide");
// },
// };
</script>

<style lang="scss">
/*每个页面公共css */
.uni-easyinput ::v-deep .is-focused {
  border-color: #ffdd00 !important;
}
.uni-easyinput ::v-deep .is-focused .content-clear-icon::before {
  color: #ffdd00 !important ;
}
.uni-easyinput ::v-deep .is-focused .uni-easyinput__content-input {
  color: #030303 !important ;
}
</style>
